import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Clock, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
import { sports } from '../data/sports';
export function Sports() {
  return <div className="w-full bg-club-canvas" data-id="element-1233">
      {/* Page Banner */}
      <section className="relative h-[50vh] min-h-[400px] flex items-center justify-center overflow-hidden" data-id="element-1234">
        <div className="absolute inset-0 z-0" data-id="element-1235">
          <img src="https://images.unsplash.com/photo-1534438327276-14e5300c3a48?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80" alt="Sports & Wellness" className="w-full h-full object-cover" data-id="element-1236" />
          <div className="absolute inset-0 bg-club-navy/50 mix-blend-multiply" data-id="element-1237"></div>
        </div>
        <div className="relative z-10 text-center px-4 mt-16" data-id="element-1238">
          <motion.span className="eyebrow text-club-gold mb-4 block" initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-1239">
            Active Lifestyle
          </motion.span>
          <motion.h1 className="text-5xl md:text-6xl font-serif text-white mb-6" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2,
          duration: 0.6
        }} data-id="element-1240">
            Sports & Wellness
          </motion.h1>
        </div>
      </section>

      {/* Intro */}
      <section className="py-20 px-4 max-w-4xl mx-auto text-center" data-id="element-1241">
        <p className="text-xl text-club-ink/80 font-light leading-relaxed mb-8" data-id="element-1242">
          Andhra Social & Cultural Association provides world-class sporting
          facilities designed to support your active lifestyle. Whether you are
          seeking competitive play, professional instruction, or leisurely
          recreation, our extensive amenities cater to every athletic pursuit.
        </p>
      </section>

      {/* Sports Grid */}
      <section className="py-12 px-4 max-w-7xl mx-auto mb-24" data-id="element-1243">
        <div className="space-y-16" data-id="element-1244">
          {sports.map((sport, index) => <motion.div key={sport.id} className={`flex flex-col ${index % 2 !== 0 ? 'md:flex-row-reverse' : 'md:flex-row'} gap-12 items-center`} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-1245">
              <div className="w-full md:w-1/2" data-id="element-1246">
                <div className="aspect-[4/3] overflow-hidden rounded-sm relative group" data-id="element-1247">
                  <img src={sport.image} alt={sport.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-1248" />
                </div>
              </div>
              <div className="w-full md:w-1/2 space-y-6" data-id="element-1249">
                <h2 className="text-4xl" data-id="element-1250">{sport.name}</h2>
                <p className="text-club-ink/70 leading-relaxed text-lg" data-id="element-1251">
                  {sport.desc}
                </p>

                <div className="bg-white p-6 border border-club-border rounded-sm mt-6" data-id="element-1252">
                  <div className="flex items-start gap-3" data-id="element-1253">
                    <Clock size={20} className="text-club-gold shrink-0 mt-0.5" data-id="element-1254" />
                    <div data-id="element-1255">
                      <h4 className="font-medium text-club-ink text-sm uppercase tracking-wider mb-1" data-id="element-1256">
                        Hours
                      </h4>
                      <p className="text-club-ink/70 text-sm" data-id="element-1257">
                        {sport.timings}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="pt-4 flex gap-4" data-id="element-1258">
                  <Link to={`/sports/${sport.id}`} className="btn-primary" data-id="element-1259">
                    View Details & Book
                  </Link>
                </div>
              </div>
            </motion.div>)}
        </div>
      </section>
    </div>;
}